function incrementOption(e,classNm) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
  

  if (!isNaN(currentVal)) {
    jQuery('.'+classNm+' input[name=' + fieldName + ']').val(currentVal);
    parent.find('input[name=' + fieldName + ']').val(currentVal);
  } else {
    jQuery('.'+classNm+' input[name=' + fieldName + ']').val(0);
    parent.find('input[name=' + fieldName + ']').val(0);
  }
}
jQuery('document').ready(function(){
setTimeout(function () {
     jQuery('.sticky-input-group').on('click', '.sticky-button-plus', function(e) {
  
  incrementOption(e,'input-group');
});
    }, 500);

setTimeout(function () {
     jQuery('.sticky-input-group').on('click', '.sticky-button-minus', function(e) {
  incrementOption(e,'input-group');
});

    }, 500);


jQuery('.input-group').on('click', '.button-plus', function(e) {
  incrementOption(e,'sticky-input-group');
});

jQuery('.input-group').on('click', '.button-minus', function(e) {
  incrementOption(e,'sticky-input-group');
});
});

jQuery(document).ready(function () {
  
  if(jQuery('#rc_container').length > 0){ 
		jQuery('#add-onetime').addClass('hide');
  }
  else{
  		jQuery('#add-subscribe').addClass('hide');
  }
// Sync from top form to bottom sticky form
$('input[name=purchase_type], .rc_label__deliver_every select').on('change', function (e) {
let selVal = $(this).val();

if (selVal == 'autodeliver') {
selVal = $('[id^=rc_shipping_interval_frequency-]').val();
jQuery('#add-subscribe').removeClass('hide');
jQuery('#add-onetime').addClass('hide');
}

if(typeof selVal != 'undefined'){
jQuery('body #sticky_rc_shipping_interval_frequency').val(selVal).trigger('change');
}
});

// Sync from bottom form to top sticky form /
jQuery('body #sticky_rc_shipping_interval_frequency').on('change', function () {
let selVal = jQuery(this).val();
if (selVal == 'onetime') {
$('input[name=purchase_type]:first').trigger('click');
jQuery('#add-subscribe').addClass('hide');
jQuery('#add-onetime').removeClass('hide');
} else if (selVal == '1' ||selVal == '2' || selVal == '3' || selVal == '4') {
selVal = parseInt(selVal);
  jQuery('#add-onetime').addClass('hide');
  jQuery('#add-subscribe').removeClass('hide');
$('input[name=purchase_type]:last').trigger('click');
$('[id^=rc_shipping_interval_frequency-]').trigger('click').val(selVal);
jQuery('#add-subscribe').removeClass('hide');
jQuery('#add-onetime').addClass('hide');
}
});
  jQuery('#add-onetime').on('click',function(){
  jQuery('form#add-item-form #add-to-cart').trigger('click');
  });
  jQuery('#add-subscribe').on('click',function(){
  jQuery('form#add-item-form #subscribe-add').trigger('click');
  });
});